export function normalizeDescriptionsItemChildren(value: unknown): unknown {
  if (value === undefined || value === null || value === "") return "-";
  return value;
}

export function buildDescriptionsSlotData(
  item: Record<string, unknown>,
  index: number,
) {
  const itemKey = String(item.key || "").trim();
  const rawValue = item.children;
  return {
    item,
    index,
    key: itemKey,
    label: item.label,
    value: rawValue,
    rawValue,
    displayValue: rawValue,
  };
}
